import { render, staticRenderFns } from "./PortraitSvg.vue?vue&type=template&id=2634abea&scoped=true&"
import script from "./PortraitSvg.vue?vue&type=script&lang=js&"
export * from "./PortraitSvg.vue?vue&type=script&lang=js&"
import style0 from "./PortraitSvg.vue?vue&type=style&index=0&id=2634abea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634abea",
  null
  
)

export default component.exports